import classNames from 'classnames';
import type { FC } from 'react';
import colors from 'theme/colors';
import { Tooltip } from './TooltipV2';

const themes = {
  taxes: {
    color: 'text-taxes-800',
    borderColor: colors.taxes[800],
  },
  expenses: {
    color: 'text-expenses-800',
    borderColor: colors.expenses[800],
  },
  revenues: {
    color: 'text-revenues-800',
    borderColor: colors.revenues[800],
  },
  bank: {
    color: 'text-bank-800',
    borderColor: colors.bank[800],
  },
  primary: {
    color: 'text-primary',
    borderColor: colors.primary[800],
  },
};

const CountProgressBadge: FC<{
  count: number | string;
  percentage?: number;
  textClassName?: string;
  tooltipContent?: string;
  color?: 'taxes' | 'expenses' | 'revenues' | 'bank' | 'primary';
  className?: string;
}> = ({
  count,
  percentage = 0,
  textClassName,
  tooltipContent,
  color,
  className,
}) => {
  const clampedPercentage = Math.min(100, Math.max(0, percentage));

  const radius = 10;

  const circumference = 2 * Math.PI * radius;

  const strokeDashoffset =
    circumference - (clampedPercentage / 100) * circumference;

  const theme = themes[color as keyof typeof themes];

  return (
    <div className={className}>
      <Tooltip content={tooltipContent}>
        <div className="relative inline-block">
          <div className="absolute inset-0 flex items-center justify-center">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              className="-rotate-90"
            >
              <circle
                cx="12"
                cy="12"
                r={radius}
                fill="none"
                stroke="rgba(255, 255, 255)"
                strokeWidth="2"
              />
              <circle
                cx="12"
                cy="12"
                r={radius}
                fill="none"
                stroke={theme?.borderColor}
                strokeWidth="2"
                strokeDasharray={circumference}
                strokeDashoffset={strokeDashoffset}
                strokeLinecap="round"
                style={{
                  transition: 'stroke-dashoffset 0.5s ease-in-out',
                }}
              />
            </svg>
          </div>

          <div
            className={classNames(
              'flex items-center justify-center',
              'w-6 h-6',
              'text-[12px] !font-bold',
              'relative z-[500]',
              theme?.color,
              textClassName,
            )}
          >
            {count}
          </div>
        </div>
      </Tooltip>
    </div>
  );
};

export default CountProgressBadge;
